export default function config() {
  Array.from(document.querySelectorAll('.autoblur')).forEach((el) =>
    el.dispatchEvent(new Event('blur'))
  )
}
